import * as React from 'react';
import { ConfigurationNewForm } from '../../../../Partials';
import { connect } from 'react-redux';

import { FormattedMessage } from 'react-intl';
import MESSAGES from './ConfigurationNew.messages';
import { PricingsDispatcher } from 'src/app/Container/Dispatcher/PricingsDispatcher';

export interface ConfigurationNewProps {
  dispatch: Function;
}

export class ConfigurationNewPage extends React.Component<ConfigurationNewProps> {
  public render() {
    return (
      <div className="page-configuration-new d-flex justify-content-center align-items-center vh-100">
        <PricingsDispatcher />
        
        <div className="container">
          <div className="row">
            <div className="col-12 col-md-8 offset-md-2">
              <h3 className="text-center mb-5">
                <FormattedMessage {...MESSAGES.configurationNewHeadline} />
              </h3>
              <ConfigurationNewForm formFields={undefined} />
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export const ConfigurationNew = connect()(ConfigurationNewPage);

export default ConfigurationNew;
